// This file was generated using `pay js:run gql-v1 --type=mutation --name=AttemptExternalAccountChallenge --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1MutationOptionsWithoutVariables,
  V1MutationOptions,
  V1MutationReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1Mutation} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, ApolloError} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1ConnectExternalAccountChallengeChallengeTokenInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation AttemptExternalAccountChallengeMutation(
    $input: OpenapiPostV1ConnectExternalAccountChallengeChallengeTokenInput
    $v1Context: V1ContextInput!
  ) {
    v1ConnectExternalAccountChallengeChallengeToken(
      input: $input
      v1Context: $v1Context
    ) {
      key
    }
  }
`;

export const attemptExternalAccountChallengeMutation: AttemptExternalAccountChallengeMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const attemptExternalAccountChallengeMutationOptions: V1MutationOptionsWithoutVariables<AttemptExternalAccountChallengeMutationDocument> =
  {
    expectedErrors: ['failed_challenge'],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...

    // TODO: This is a legacy behavior that was present in the original Apollo
    // wrappers and is not standard. If you are not using this error for anything
    // feel free to remove it (More info: go/throw-errors-on-mutations)
    onError(error: ApolloError) {
      throw error;
    },
  };

export default function useAttemptExternalAccountChallengeMutation(
  options: V1MutationOptions<AttemptExternalAccountChallengeMutationDocument> = {},
): V1MutationReturn<AttemptExternalAccountChallengeMutationDocument> {
  return useV1Mutation(
    attemptExternalAccountChallengeMutation,
    Object.assign({}, attemptExternalAccountChallengeMutationOptions, options),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type AttemptExternalAccountChallengeMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1ConnectExternalAccountChallengeChallengeTokenInput>;
  v1Context: V1ContextInput;
}>;

export type AttemptExternalAccountChallengeMutationData = {
  readonly __typename: 'Mutation';
  readonly v1ConnectExternalAccountChallengeChallengeToken: {
    readonly __typename: 'OpenapiConnectAuthResourcesExternalAccountChallenge';
    readonly key: string;
  } | null;
};

const attemptExternalAccountChallengeMutationPermissions = {} as const;

doc.permissions = attemptExternalAccountChallengeMutationPermissions;

export type AttemptExternalAccountChallengeMutationPermissions =
  V1PermissionToken<typeof attemptExternalAccountChallengeMutationPermissions>;

export type AttemptExternalAccountChallengeMutationDocument = GraphQlDocument<
  AttemptExternalAccountChallengeMutationData,
  AttemptExternalAccountChallengeMutationVariables,
  AttemptExternalAccountChallengeMutationPermissions
>;
